
function initMajeProductSectionSwiper() {
    const carousels = document.querySelectorAll('.maje-products .swiper');
    carousels.forEach(carousel => {
        const nextBtn = carousel.querySelector('.swiper-button-next');
        const prevBtn = carousel.querySelector('.swiper-button-prev');

        // console.log(nextBtn, prevBtn)

        const swiper = new Swiper(carousel, {
            loop: true,
            draggable: true,
            slidesPerView: 1,
            speed: 1000,
            navigation: {
              nextEl: nextBtn,
              prevEl: prevBtn,
            },
        });
    })

}

initMajeProductSectionSwiper();

function initCartDrawerCarousel() {
    const carousel = document.querySelector('.swiper.swiper-cart-drawer');

    if (!carousel) return;

    const nextBtn = carousel.querySelector('.swiper-button-next');
    const prevBtn = carousel.querySelector('.swiper-button-prev');

    // console.log(nextBtn, prevBtn)

    const swiper = new Swiper(carousel, {
        loop: true,
        draggable: true,
        slidesPerView: 1,
        speed: 1000,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
    });
}

initCartDrawerCarousel();